export const DEFAULT_POI_PICTURE =
  'https://supplement-bacon.com/wp-content/uploads/2020/09/bg.png'
